/**
 * Availability section dictionary
 */
export enum AvailabilitySections {
  SpaceDetails = 1,
  Terms = 2,
  IndustrialSpecifications = 3,
  Property = 4,
  Companies = 5,
  FloorSuite = 58,
  Contact = 6,
  Privacy = 153,
  Tags = 94,
  Admin = 7,
  Summary = 167,
  PropertyExternalRatings = 177,
  PropertyMeasurement = 178,
  AvailabilityAmenities = 159,
  Listings = 143,
  GroupByProperty = 196,
  Companies_ListingReps = 239,
  Contacts_ListingReps = 240,
  Companies_Other = 241,
  Contacts_Other = 242,
  Frontage = 222,
}

/**
 * Brand section dictionary
 */
export enum BrandSections {
  BrandDetails = 120,
  Companies = 121,
  Contacts = 122,
  Summary = 175,
}

/**
 * Company section dictionary
 */
export enum CompanySections {
  CompanyDetails = 22,
  Locations = 53,
  PhoneInfo = 56,
  IndustryClassification = 55,
  DigitalInfo = 57,
  LocationPhoneInfo = 73,
  Tags = 97,
  Admin = 26,
  Summary = 170,
  CompanyHierarchyWidget = 256,
  IndustryType = 258,
}

/**
 * Contact section dictionary
 */
export enum ContactSections {
  ContactDetails = 27,
  Privacy = 29,
  Companies = 30,
  PhoneInfo = 51,
  DigitalInfo = 52,
  Tags = 98,
  Admin = 34,
  Summary = 171,
}

/**
 * Lease section dictionary
 */
export enum LeaseSections {
  LeaseCompDetails = 35,
  Terms = 36,
  EscalationDetails = 81,
  Expenses = 37,
  IndustrialSpecifications = 38,
  Property = 39,
  Companies = 40,
  Contacts = 41,
  FloorSuite = 59,
  Privacy = 149,
  Tags = 100,
  Admin = 42,
  Summary = 173,
  PropertyExternalRatings = 179,
  RentReview = 157,
  RentReviewProvisions = 158,
  MeasurementArrangement = 135,
  Companies_ListingReps = 235,
  Contacts_ListingReps = 236,
  Companies_Other = 237,
  Contacts_Other = 238,
  Frontage = 251,
}

/**
 * Portfoliosale section dictionary
 */
export enum PortfoliosaleSections {
  PortfolioSalesDetails = 138,
  PortfolioSaleProperties = 139,
  Companies = 140,
  Contacts = 141,
  Admin = 142,
  Summary = 176,
}

/**
 * Property section dictionary
 */
export enum PropertySections {
  PropertyDetails = 102,
  OfficeDetails = 9,
  PropertyTypeDetails = 10,
  LandConstructionParking = 104,
  Address = 103,
  ElevatorFloor = 105,
  OtherPropertyCharacteristics = 106,
  Comps = 20,
  Notes = 107,
  ExternalRatings = 134,
  Companies = 17,
  Contacts = 18,
  Location = 110,
  AvailabilityVacancy = 111,
  RatesExpenses = 112,
  OtherCharacteristics = 113,
  IndustryClassification = 61,
  IndustrialCharacteristics = 114,
  RetailCharacteristics = 115,
  LandCharacteristics = 116,
  DigitalInfo = 80,
  Tags = 95,
  Admin = 21,
  PropertyTypeAmenities = 156,
  PropertyAmenities = 155,
  PropertyNotes = 43,
  Summary = 168,
  PropertyDevelopment = 154,
  DevelopmentStatus = 160,
  PropertyDevelopment_Companies = 205,
  PropertyDevelopment_Contacts = 206,
  TransportDetails = 91,
  Measurements = 133,
  LegalDocuments = 198,
  CompaniesAndContacts = 207,
  Debt = 213,
  OperatingExpenseHistory = 214,
  Electric = 223,
  Structure = 221,
  Hvac = 220,
  Companies_ListingReps = 227,
  Contacts_ListingReps = 228,
  Companies_BuildingOwners = 229,
  Contacts_BuildingOwners = 230,
  Companies_BuildingManagement = 231,
  Contacts_BuildingManagement = 232,
  Companies_Other = 233,
  Contacts_Other = 234,
  PropertySets = 224,
}

/**
 * Sale section dictionary
 */
export enum SaleSections {
  SaleCompDetails = 49,
  Contacts = 45,
  Property = 46,
  IndustrialSpecifications = 47,
  RetailSpecifications = 48,
  Companies = 44,
  Privacy = 150,
  Tags = 99,
  Admin = 50,
  Summary = 172,
  PropertyExternalRatings = 181,
  PropertyMeasurement = 180,
  RentReview = 184,
  RentReviewProvisions = 185,
}

/**
 * Tenancy section dictionary
 */
export enum TenancySections {
  TenancyDetails = 75,
  FloorSuite = 76,
  Property = 77,
  Tags = 101,
  Admin = 78,
  Summary = 174,
}

/**
 * Tim section dictionary
 */
export enum TimSections {
  TIMCompany = 71,
  TIMDetails = 65,
  CurrentLocationDetails = 68,
  TargetPropertyType = 74,
  CurrentLocations = 79,
  TargetLocations = 67,
  Companies = 69,
  Contacts = 70,
  Privacy = 151,
  Tags = 96,
  Admin = 66,
  Summary = 169,
}
